import React from "react";
import { Box, Typography } from "@mui/material";
import TextEditor from "../../../components/TextEditor";

function TermsAndCondition({ edit, formData, onChangeTextEditor }) {
  return (
    <>
      <Typography sx={{ fontSize: "24px", marginBottom: "1rem" }}>
        Add Terms & Condition
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <TextEditor
          edit={edit}
          id="en"
          placeholder="Enter Terms & Condition in English"
          prefill={formData.termsAndCondition?.en || ""}
          onChangeTextEditor={onChangeTextEditor}
        />
        <TextEditor
          edit={edit}
          id="hi"
          placeholder="Enter Terms & Condition in Hindi"
          prefill={formData.termsAndCondition?.hi || ""}
          onChangeTextEditor={onChangeTextEditor}
        />
        <TextEditor
          edit={edit}
          id="fr"
          placeholder="Enter Terms & Condition in French"
          prefill={formData.termsAndCondition?.fr || ""}
          onChangeTextEditor={onChangeTextEditor}
        />
        <TextEditor
          edit={edit}
          id="es"
          placeholder="Enter Terms & Condition in Spanish"
          prefill={formData.termsAndCondition?.es || ""}
          onChangeTextEditor={onChangeTextEditor}
        />
      </Box>
    </>
  );
}

export default TermsAndCondition;
